import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Grid, Select, TextField } from '@mui/material';
import Usuario from '../../pages/Usuarios';
import 'swiper/css';
import 'swiper/css/scrollbar';
import '../../assets/css/carrusel.css';

const CustomSelect = ({ label, value, onChange, options }) => {
  return (
    <FormControl size="small" sx={{ ...textfieldStyle }}>
      <InputLabel id="custom-select-label">{label}</InputLabel>
      <Select
        labelId="custom-select-label"
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          fontSize: '1.9vh',
          textAlign: 'center',
          mt: '0.2vh',
          height: '4.5vh',
          color: 'rgba(255,255,255,0.7)',
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: '#252525',
              '& .MuiMenuItem-root': {
                fontSize: '.65vw',
                color: '#fff',
                '&:hover': { backgroundColor: '#353535' },
              },
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ fontSize: '1.8vh' }}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const UserForm = ({
  translate,
  cargo,
  usuarios,
  initialUser,
  user,
  setEditar,
  editar,
  setUser,
  handleInputChange,
  actualizarListaUsuarios,
  usuarioSeleccionado,
  setUsuarioSeleccionado,
  passwordError,
  setPasswordError,
}) => {
  const [usuariosActualizados, setUsuariosActualizados] = useState([]);
  const [opciones, setOpciones] = useState([]);
  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*\W).{6,}$/;

  useEffect(() => {
    let opcionesActualizadas = [];
    switch (cargo) {
      case 'Jefe Area':
        opcionesActualizadas = [
          { value: 'Jefe Centro', label: translate('jefe_centro') },
          { value: 'Operario', label: translate('operario') },
        ];
        break;
      case 'Jefe Centro':
        opcionesActualizadas = [{ value: 'Operario', label: translate('operario') }];
        break;
      case 'Jefe Region':
        opcionesActualizadas = [
          { value: 'Jefe Area', label: translate('jefe_area') },
          { value: 'Jefe Centro', label: translate('jefe_centro') },
          { value: 'Operario', label: translate('operario') },
        ];
        break;
      case 'Gerencia':
        opcionesActualizadas = [
          { value: 'Jefe Region', label: translate('jefe_region') },
          { value: 'Jefe Area', label: translate('jefe_area') },
          { value: 'Jefe Centro', label: translate('jefe_centro') },
          { value: 'Operario', label: translate('operario') },
        ];
        break;
      default:
        opcionesActualizadas = [
          { value: 'Gerencia', label: translate('gerencia') },
          { value: 'Jefe Region', label: translate('jefe_region') },
          { value: 'Jefe Area', label: translate('jefe_area') },
          { value: 'Jefe Centro', label: translate('jefe_centro') },
          { value: 'Operario', label: translate('operario') },
        ];
    }
    setOpciones(opcionesActualizadas);
  }, [cargo, translate]);

  useEffect(() => {
    if (usuarios !== usuariosActualizados) {
      setUsuariosActualizados(usuarios);
    }
  }, [usuarios, usuariosActualizados]);

  const handleCargoChange = (nuevoCargo) => {
    setUser((prev) => ({ ...prev, cargo: nuevoCargo }));
  };

  const validatePassword = (value) => {
    if (!passwordRegex.test(value)) {
      setPasswordError(translate('password_requirements'));
    } else {
      setPasswordError('');
    }
  };

  return (
    <Grid container justifyContent="center">
      <Grid container justifyContent="center" sx={{ mt: '5vh', mb: '4vh', width: '100vw', gap: 2 }}>
        <TextField
          fullWidth
          name="username"
          value={user.username}
          sx={{ ...textfieldStyle }}
          placeholder={translate('username')}
          onChange={handleInputChange}
        />
        <TextField
          fullWidth
          name="correo"
          value={user.correo}
          type="email"
          sx={{ ...textfieldStyle }}
          placeholder={translate('email')}
          onChange={handleInputChange}
        />
        {!editar && (
          <TextField
            fullWidth
            name="password"
            type="password"
            sx={{ ...textfieldStyle }}
            placeholder={translate('password')}
            onChange={(e) => {
              handleInputChange(e);
              validatePassword(e.target.value);
            }}
          />
        )}
        {passwordError && <p style={{ color: '#e94e1a', top: '40vh', left:'57vw', position:'absolute' }}>{passwordError}</p>}
        <CustomSelect
          label={translate('selected_cargo')}
          value={user.cargo}
          onChange={handleCargoChange}
          options={opciones}
        />
      </Grid>
      <Grid>
        <Usuario
          translate={translate}
          initialUser={initialUser}
          usuarios={usuarios}
          user={user}
          setEditar={setEditar}
          editar={editar}
          setUser={setUser}
          actualizarListaUsuarios={actualizarListaUsuarios}
          usuarioSeleccionado={usuarioSeleccionado}
          setUsuarioSeleccionado={setUsuarioSeleccionado}
        />
      </Grid>
    </Grid>
  );
};

export default UserForm;

const textfieldStyle = {
  width: '12vw',
  ml: '1vw',
  '& .MuiOutlinedInput-root': {
    '& fieldset': { borderColor: 'rgba(233, 78, 26, .3)' },
    '&:hover fieldset': { borderColor: 'rgba(233, 78, 26, .7)' },
    '&.Mui-focused fieldset': { borderColor: 'rgba(233, 78, 26, .9)' },
    '& .MuiInputBase-input': { color: '#c3c3c3', fontSize: '0.8vw' },
    '& .MuiSelect-select': { textAlign: 'center' },
    '& .MuiSelect-icon': { color: 'rgba(255,255,255,0.7)', fontSize: '1vw' },
  },
  '& .MuiInputLabel-root': {
    color: '#c3c3c3',
    fontSize: '0.8vw',
    top: '50%',
    left: '35%',
    transform: 'translateY(-50%)',
    transition: 'all 0.2s ease',
  },
  '& .MuiInputLabel-shrink': {
    top: '-50%',
    left: '9%',
    transform: 'translateY(0)',
    fontSize: '0.7vw',
  },
};
